export const Message = ({ author, time, content, image, isOutgoing }) => {
  const messageContainerClasses = isOutgoing
    ? "flex justify-end items-start w-full"
    : "flex items-start w-full";

  const innerContainerClasses = isOutgoing
    ? "flex flex-1 gap-3 justify-end items-start max-w-[272px]"
    : "flex flex-1 gap-3 items-start max-w-[312px]";

  const messageContentClasses = isOutgoing
    ? "flex-1 gap-2 px-3.5 py-2.5 w-full text-base leading-6 text-white bg-teal-600 rounded-lg"
    : "flex-1 gap-2 px-3.5 py-2.5 w-full text-base leading-6 text-gray-900 rounded-none border border-gray-200 bg-neutral-50";

  return (
    <article className={messageContainerClasses}>
      <div className={innerContainerClasses}>
        {!isOutgoing && (
          <img
            src={image}
            alt={`${author}'s avatar`}
            className="w-[40px] h-[40px] rounded-[9999px]"
          />
        )}
        <div className="flex flex-col flex-1 gap-1.5 items-start">
          <div className="flex gap-2 items-center w-full">
            <div className="overflow-hidden flex-1 text-sm font-medium leading-5 text-gray-700 text-ellipsis">
              {author}
            </div>
            <time className="text-xs leading-5 text-gray-600">{time}</time>
          </div>
          <p className={messageContentClasses}>{content}</p>
        </div>
      </div>
    </article>
  );
};
